/**
 * Created by Alex Aguilar on 7/29/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('addAirportsController', addAirportsController)
        .controller('addEditAirportController', addEditAirportController)
        .controller('deleteAddAirportController', deleteAddAirportController)

    addAirportsController.$inject = ['airports', 'linkService'];
    addEditAirportController.$inject = ['airport', 'linkService', 'airportService','isEdit'];
    deleteAddAirportController.$inject = ['airport', '$stateParams', '$uibModalInstance', 'airportService'];

    function addAirportsController(airports, linkService){
        var vm = this;
        vm.pages = [];
        vm.linkService = linkService;
        vm.airports = (airports.data._embedded) ? airports.data._embedded.airports : [];
        vm.pages = airports.data.page;
    }

    function addEditAirportController(airport, linkService, airportService, isEdit){
        var vm = this;
        vm.isEdit = isEdit;
        vm.disableSelects = (airport == null) ? false : true;
        vm.airport = airport;
        vm.linkService = linkService;
        vm.airports = [];
        vm.searchAirport = "";
        vm.airportForm = {
            'airportId': (airport == null) ? 0 : parseInt(linkService.getLinkId(airport.data._links.self.href)),
            'searchAirport': (airport == null) ? "" : airport.data.name,
            'boardingGates': (airport == null) ? [] : airport.data._embedded.boardinggates
        }
        vm.buttonSave = true;
        if(!vm.isEdit){
            vm.buttonSave = false;
        }
        vm.old = angular.copy(vm.airportForm.boardingGates);

        /*vm.search = function(search){
            if(search != undefined && search != ""){
                vm.airports = [];
                airportService.searchByIataAndName(search)
                    .then(function(response){
                        vm.airports = response;
                    });
            }else{
                vm.airports = [];
                vm.boardingGates = [];
                vm.airportForm.airportId = 0;
            }
        }*/

        vm.eventHandleAirport = function (airport) {
            if(airport !== null){
                vm.airports = [];
                vm.airportForm.searchAirport = airport.name;
                vm.airportForm.airportId = parseInt(linkService.getLinkId(airport._links.self.href));
                vm.airportForm.boardingGates.push({
                    'number': ''
                });
            }else{
                vm.airports = [];
                vm.airportForm.searchAirport = "";
                vm.airportForm.airportId = 0;
                vm.airportForm.boardingGates = [];
            }
        }

        /*vm.selectSearch = function(airport){
            if(airport != undefined){
                vm.airports = [];
                vm.airportForm.searchAirport = airport.name;
                vm.airportForm.airportId = parseInt(linkService.getLinkId(airport._links.self.href));
                vm.airportForm.boardingGates.push({
                    'number': ''
                });
            }else{
                vm.airports = [];
                vm.airportForm.searchAirport = "";
                vm.airportForm.airportId = 0;
                vm.airportForm.boardingGates = [];
            }
        }*/

        vm.addBoardingGates = function(){
            vm.airportForm.boardingGates.push({
                'number': '',
                'predefined': false
            });
        }

        vm.deleteBoardingGates = function(index){
            vm.airportForm.boardingGates.splice(index, 1)
        }

        vm.saveAirport = function(isValid, airportForm){
            var boardingGates = [];
            addBoardingGates(boardingGates, airportForm);
            airportService.updateAirportActive(airportForm.airportId, {'boardingGates': boardingGates}, airport)
                .then(function(){
                });
        }

        vm.changeHandler = function (form, boardinGateIndex, index) {
            if(vm.isEdit){
                var flag = false;
                if(form[boardinGateIndex].$modelValue != undefined){
                    for(var i=0; i < vm.airportForm.boardingGates.length; i++){
                        if(i != index){
                            if(vm.airportForm.boardingGates[i].number == form[boardinGateIndex].$modelValue){
                                flag = true;
                                break;
                            }
                        }
                    }
                    form[boardinGateIndex].$setValidity('uniqueBoardingGateNumber', !flag);
                }else{
                    form[boardinGateIndex].$setValidity('uniqueBoardingGateNumber', true);
                    form[boardinGateIndex].$setValidity('required', false);
                }
            }
        }

        vm.change = function(){
            if(vm.isEdit){
                vm.buttonSave = true;
                if(vm.airportForm.boardingGates.length == vm.old.length){
                    for(var i=0; i<vm.airportForm.boardingGates.length; i++){
                        var flag = false;
                        for(var j=0; j<vm.old.length; j++){
                            if(vm.airportForm.boardingGates[i].number == vm.old[j].number){
                                flag = true;
                                break;
                            }
                        }
                        if(!flag){
                            vm.buttonSave = false;
                            break;
                        }
                    }
                }else{
                    vm.buttonSave = false;
                }
            }
        }
    }

    function deleteAddAirportController(airport, $stateParams, $uibModalInstance, airportService){
        var vm = this;
        vm.airportId = $stateParams.id;
        vm.airport = airport.data;

        vm.deleteAddAirport = function(){
            airportService.updateAirportDisable(vm.airportId)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function addBoardingGates(boardingGates, airportForm){
        if(airportForm.boardingGates.length > 0){
            angular.forEach(airportForm.boardingGates, function(boardingGate, index){
                boardingGates.push({number: boardingGate.number,predefined:(index==0?true:false)})
            });
        }
        return boardingGates;
    }

})();
